import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, BrowserEvents } from '../global/constants';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Animations ----------

};

$Elements.document.on(BrowserEvents.page.enter, () => initBaseAnimations());
